import React from 'react';
import {
  CardMedia,
  Card,
  CardTitle,
  Button,
  Typography
} from '@one-thd/sui-atomic-components';
import classNames from 'classnames';
import { useImpression } from '@thd-olt-component-react/impression';
import { useQuoteContext } from '../../../hooks/useQuoteContext';
import QuotesHeader from '../QuotesHeader';
import fallbackViewTexts from '../../../constants/fallbackViewTexts';
import { nullStatePropTypes } from './nullStatePropTypes';

const DesktopNullView = ({
  imageUrl,
  imageAlt
}) => {
  const { componentId, isDashboardSnapshot } = useQuoteContext();
  const { ref, clickID } = useImpression({
    data: {
      component: 'QuotesFallbackView',
      name: 'QuotesFallbackView',
      id: componentId,
      position: 1,
      type: 'content',
    }
  });

  const {
    cardTitle,
    bodyText,
    learnMoreText
  } = fallbackViewTexts;

  return (
    <Card
      data-component="Quotes"
      data-testid="desktop-null-view"
      className="sui-h-full"
      orientation="horizontal"
      CardContentProps={{
        className: classNames(
          'sui-flex',
          'sui-flex-col',
          'sui-p-4',
          'sui-w-full',
          'sui-h-full',
        )
      }}
      // Dashboard Snapshot (Figma "Desktop Null"): no border, like the snapshot's other cards;
      // no header row, since the tab already names the tool; image rounded inside the inset;
      // the button hugs its label.
      PaperProps={isDashboardSnapshot ? { variant: 'shadow', shadow: 'none' } : undefined}
      ref={ref}
      clickid={clickID}
    >
      <div className="sui-@container sui-flex sui-gap-4 sui-h-full sui-w-full">
        <div className="sui-flex sui-flex-col sui-flex-1 sui-h-full">
          {!isDashboardSnapshot && <QuotesHeader hideActionLink />}
          <div className={classNames('sui-flex sui-flex-col sui-h-full', { 'sui-mt-6': !isDashboardSnapshot })}>
            <CardTitle
              headerVariant="h3"
              headerWeight="display"
              header={<span style={{ whiteSpace: 'pre-line' }}>{cardTitle}</span>}
            />
            <div className="sui-mt-2">
              <Typography>
                {bodyText}
              </Typography>
            </div>
            <div className="sui-mt-auto sui-pt-4">
              <Button
                variant="secondary"
                fullWidth={!isDashboardSnapshot}
                href="/c/create-a-quote"
              >
                {learnMoreText}
              </Button>
            </div>
          </div>
        </div>
        <div
          className={classNames('sui-hidden @lg:sui-block sui-flex-1 sui-overflow-hidden', {
            'sui-rounded-md': isDashboardSnapshot
          })}
        >
          <CardMedia
            src={imageUrl}
            alt={imageAlt}
            className="sui-w-full sui-h-full sui-transform sui-object-cover sui-object-center"
          />
        </div>
      </div>
    </Card>
  );
};

DesktopNullView.propTypes = nullStatePropTypes;

export default DesktopNullView;
